import React from 'react';
import SignUpForm from '../components/SignUpForm';

const SignUp = () => (
  <main className="container mx-auto mt-8 p-4">
    <h2 className="text-3xl font-bold mb-4 text-center">Create Your Account</h2>
    <SignUpForm />
  </main>
);

export default SignUp;